<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">OTP - Results History</span><br/>
      <span style="font-style: italic; font-size: 18px">use this page to view results for the selected date range and route - note, limit of 5k results, narrow search range if needed</span>
    </div>
    <div style="font-size: 18px; font-weight: bold; position: relative" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      <span v-if="route_options.length > 0">
        &nbsp;&nbsp;Route Group:&nbsp;<b-form-select v-model="route_filter" :options="route_options" style="font-size: 18px; font-weight: bold; width:120px"/>
      </span>
      &nbsp;&nbsp;Trips:&nbsp;<b-form-select v-model="trip_filter" :options="trip_options" style="font-size: 18px; font-weight: bold; width:200px"/>
      &nbsp;&nbsp;Vehicles:&nbsp;<b-form-select v-model="vehicle_filter" :options="vehicle_options" style="font-weight: bold;width:140px"/>
    </div>
    <br/>
    <div style="font-size: 18px; font-weight: bold; position: relative" class="align-right d-flex align-items-center justify-content-center">
      &nbsp;&nbsp;Drivers:&nbsp;<b-form-select v-model="driver_filter" :options="driver_options" style="font-weight: bold; width:200px"/>
      &nbsp;&nbsp;Stops:&nbsp;<b-form-select v-model="stop_filter" :options="stop_options" style="font-size: 14px; font-weight: bold; max-width:370px"/>
      &nbsp;&nbsp;<b-button v-if="!loading" size="md" @click="load_data()">Search</b-button>
      &nbsp;&nbsp;<b-button v-if="!loading" size="md" @click="check_features()">Reset</b-button>
      &nbsp;&nbsp;<div v-if="!loading && summary.total_cnt == items.length" style="margin-right: 20px;" class="totals">
        {{summary.total_cnt}} results
      </div>
      <div v-else-if="!loading" style="margin-right: 20px;" class="totals">
        {{items.length}} of {{summary.total_cnt}} results
      </div>
      <div class="margin-right: 20px;">
        <b-button size="md" variant="success" @click="download">Download</b-button>
        &nbsp;&nbsp;
        <b-button size="md" variant="success" @click="send_report">Email Report</b-button>
      </div>
    </div>
    <hr/>
    <div v-if="summary.total_cnt" style="font-size: 18px; font-weight: bold; position: relative" class="align-right d-flex align-items-center justify-content-center">
      <span style="font-size: 20px; font-weight: bold;">Filters Results:&nbsp;&nbsp;</span>
      <span style="background: #eee; position: relative; padding: 6px 12px 6px 1px" class="totals align-right d-flex align-items-center justify-content-center">
      &nbsp;&nbsp;Type:&nbsp;<b-form-select v-model="type_filter" :options="type_options" style="font-size: 16px;width:110px"/>
      &nbsp;&nbsp;Status:&nbsp;<b-form-select v-model="status_filter" :options="status_options" style="font-size: 16px;width:110px"/>
      &nbsp;&nbsp;Early:&nbsp;<b-form-select v-model="early_limit" :options="duration_threshold_options" style="font-size: 16px;width:90px"/>
      &nbsp;&nbsp;Late:&nbsp;<b-form-select v-model="late_limit" :options="duration_threshold_options" style="font-size: 16px;width:90px"/>
      </span>

    </div>
    <br/>
    <div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="Trip" slot-scope="row">
          <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/vehicle_route_history?date=' + row.item.Scheduled.split(' ')[0] + '&routeName=' + row.item.Trip }">{{ row.item.Trip }}</router-link>
        </template>

        <template slot="Stop" slot-scope="row">
          <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/route_addresses?address=' + encodeURIComponent(row.item.Stop) + '&routeName=' + row.item.Trip }">{{ row.item.Stop }}
            <span v-if="row.item.StopID">[{{row.item.StopID}}]</span>
          </router-link>
        </template>


      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>

  </div>

</template>
<script>
import {api_url, get_otp_history, get_route_patterns} from '../networking/apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from "axios";

export default {
  name: 'otp_history',

  components: {
  },

  data() {
    return {
      route_options: [],
      route_filter: '',
      trip_options: [],
      stop_options: [],
      vehicle_options: [],
      driver_options: [],
      status_options: [],
      early_limit: null,
      late_limit: null,
      trip_filter: '',
      stop_filter: '',
      vehicle_filter: '',
      driver_filter: '',
      status_filter: '',
      type_filter: '',
      items: [],
      items_full: [],
      summary: {},
      details_fromDate: justDate(moment().subtract(1, 'days')),
      details_toDate: justDate(moment().subtract(1, 'days')),
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      loading: false,
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
      duration_threshold_options: [
        { value: null, text: 'All' },
        { value: '1', text: '> 1m' },
        { value: '2', text: '> 2m' },
        { value: '5', text: '> 5m' },
        { value: '7', text: '> 7m' },
        { value: '10', text: '> 10m' },
        { value: '20', text: '> 20m' },
        { value: '30', text: '> 30m' },
      ],
      type_options: [
        { value: '', text: 'All' },
        { value: 'Arrival', text: 'Arrival' },
        { value: 'Departure', text: 'Departure' }
      ],
      fields_all: [],
      fields: [
        { key: 'Trip', sortable: true},
        { key: 'Asset', sortable: true},
        { key: 'DriverName', sortable: true},
        { key: 'Stop', sortable: true},
        { key: 'Type', sortable: true},
        { key: 'Scheduled', sortable: true},
        { key: 'Actual', sortable: true},
        { key: 'StopTime', sortable: true},
        { key: 'StopDuration', sortable: true},
        { key: 'MinimumSpeed', label:'Min Speed', sortable: true},
        { key: 'Performance', label: 'Status', sortable: true},
        { key: 'Minutes', sortable: true},
        { key: 'Passengers On', label:'Pax On', sortable: true},
        { key: 'Passengers Off', label: 'Pax Off', sortable: true},
        { key: 'Cash Collected', label: 'Cash', sortable: true}
      ]
    }
  },
  async created() {

    if (moment().isoWeekday() == 1) {
      this.details_fromDate = justDate(moment().subtract(3, 'days'))
      this.details_toDate = justDate(moment().subtract(3, 'days'))
    }
    else if (moment().isoWeekday() == 7) {
      this.details_fromDate = justDate(moment().subtract(2, 'days'))
      this.details_toDate = justDate(moment().subtract(2, 'days'))
    }

    await this.check_features()
  },
  methods: {
    async check_features() {
      this.route_filter = ''
      this.trip_filter = ''
      this.vehicle_filter = ''
      this.driver_filter = ''
      this.stop_filter = ''
      this.type_filter = ''
      this.status_filter = ''
      this.early_limit = null
      this.late_limit = null
      await this.load_routes()
      await this.load_data()
    },
    async load_routes() {
      this.summary = {}
      this.items = []
      this.items_full = []
      const {value: {data = []}} = await get_route_patterns(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
      this.route_options = data
    },
    async load_data(){

      this.loading = true

      let adj_stop_filter = encodeURIComponent(this.stop_filter)

      const {value: {data = []}} = await get_otp_history(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),this.route_filter, this.trip_filter, adj_stop_filter, this.vehicle_filter, this.driver_filter)
      this.summary = data.summary
      moment.tz.setDefault(this.summary.timezone)
      this.items = data.results
      this.items_full = data.results
      this.trip_options = this.summary.trips
      this.stop_options = this.summary.stops
      this.vehicle_options = this.summary.vehicles
      this.driver_options = this.summary.drivers
      this.status_options = this.summary.status_options

      this.loading = false

    },
    async send_report() {

      this.$emit('showAlert', 'Processing your report request', 'info', 5000)

      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}bookings/reports/otp/history/send`,
          {
            tenant: this.user.tenant,
            from_date: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            to_date: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            route_filter: this.route_filter,
            // trip_filter: this.trip_filter,
            // stop_filter: adj_stop_filter,
            // vehicle_filter: this.vehicle_filter,
            // driver_filter: this.driver_filter
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/json'
            },
            responseType: 'text'
          }
      ).then((response) => {
        this.$emit('showAlert', 'Report Sent!', 'success', 3500)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'no data found', 'warning', 3500)
      })
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info')
      let adj_stop_filter = encodeURIComponent(this.stop_filter)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}bookings/reports/otp/history/download`,
          {
            tenant: this.user.tenant,
            from_date: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            to_date: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            route_filter: this.route_filter,
            trip_filter: this.trip_filter,
            stop_filter: adj_stop_filter,
            vehicle_filter: this.vehicle_filter,
            driver_filter: this.driver_filter
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `otp-${this.user.tenant}-${this.details_fromDate}-${this.details_toDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger', 5000)
      })
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_items() {
      this.items = this.items_full
      if (this.route_filter && this.route_filter != '*') {
        this.items = this.items.filter(item => item.Trip.startsWith(this.route_filter))
        this.trip_options = this.summary.trips.filter(item => item.value.startsWith(this.route_filter))
      }
      if (this.trip_filter)
        this.items = this.items.filter(item => item.Trip == this.trip_filter)
      if (this.stop_filter)
        this.items = this.items.filter(item => this.contains(item.Stop,this.stop_filter))
      if (this.vehicle_filter)
        this.items = this.items.filter(item => this.contains(item.Asset,this.vehicle_filter))
      if (this.driver_filter)
        this.items = this.items.filter(item => this.contains(item.DriverName,this.driver_filter))
      if (this.status_filter)
        this.items = this.items.filter(item => this.contains(item.Performance,this.status_filter))
      if (this.type_filter)
        this.items = this.items.filter(item => this.contains(item.Type,this.type_filter))
      if (this.early_limit)
        this.items = this.items.filter(item => item.Performance == 'Early' && ((Math.abs(item.Minutes) > this.early_limit)))
      if (this.late_limit)
        this.items = this.items.filter(item => item.Performance == 'Late' && ((Math.abs(item.Minutes) > this.late_limit)))
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    route_filter() {
      this.filter_items()
    },
    trip_filter() {
      this.filter_items()
    },
    stop_filter() {
      this.filter_items()
    },
    vehicle_filter() {
      this.filter_items()
    },
    driver_filter() {
      this.filter_items()
    },
    status_filter() {
      this.filter_items()
    },
    early_limit() {
      this.filter_items()
    },
    late_limit() {
      this.filter_items()
    },
    type_filter() {
      this.filter_items()
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY'))
        this.details_toDate = this.details_fromDate

      const days = moment(this.details_toDate, 'MM-DD-YYYY').diff(moment(this.details_fromDate, 'MM-DD-YYYY'),'days')
      if (days > 31) {
        alert("please limit date range to 31 days or less")
        this.details_toDate = justDate(moment(this.details_fromDate, 'MM-DD-YYYY').add(1, 'month'))
      }
    },
  }
}
</script>

<style>
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }

.totals { padding: 5px 10px 5px 10px; font-size: 20px; border-radius: 5px; border: 1px solid grey;}
.filter { padding: 5px 10px 5px 10px; font-size: 22px}
</style>
